import type { ReactElement, ReactNode } from 'react';
import styled from 'styled-components';

const Container = styled.section`
  width: 100%;
  margin-top: 3.25rem;
  &:first-of-type {
    margin-top: 0;
  }
`;
const Title = styled.h2`
  ${({ theme }) => theme.typography.heading[3].normal};
  color: ${({ theme }) => theme.palette.text.onSurface.strong};
`;
const Content = styled.div<{ columnAmount?: number }>`
  width: 100%;
  display: grid;

  ${({ theme }) => theme.breakpoints.up('md')} {
    grid-template-columns: ${(props) => (props.columnAmount ? `repeat(${props.columnAmount}, 1fr)` : '')};
  }

  margin-top: 1rem;
  margin-bottom: 1.25rem;

  ${({ theme }) => theme.typography.paragraph.medium.normal};
  color: ${({ theme }) => theme.palette.text.onSurface.strong};
`;

interface PageItemProps {
  title: string;
  children: ReactNode;
  className?: string;
  columnAmount?: number;
}

export default function PageItem({ title, children, className, columnAmount }: PageItemProps): ReactElement {
  return (
    <Container className={className}>
      {title && <Title>{title}</Title>}
      <Content columnAmount={columnAmount}>{children}</Content>
    </Container>
  );
}
